/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and update a rule.
 * 
 * ``extra_params`` is validated against the action's declared spec, which is where reference
 * params are checked for resolving inside their scope — the same rule the admin's
 * ActionParamsField enforces.
 * 
 * ``position`` is read-only: the server owns it. New rules are appended, and order is changed
 * through the reorder endpoint, which is what keeps the per-action uniqueness constraint
 * satisfiable.
 * @export
 * @interface ActionRuleWrite
 */
export interface ActionRuleWrite {
    /**
     * 
     * @type {string}
     * @memberof ActionRuleWrite
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ActionRuleWrite
     */
    transitionAction: string;
    /**
     * Leave empty for a rule that always matches.
     * @type {string}
     * @memberof ActionRuleWrite
     */
    condition?: string | null;
    /**
     * Parameters passed to the action when this rule matches.
     * @type {any}
     * @memberof ActionRuleWrite
     */
    extraParams?: any | null;
    /**
     * Position of the rule in the action, used for ordering.
     * @type {number}
     * @memberof ActionRuleWrite
     */
    readonly position: number;
}

/**
 * Check if a given object implements the ActionRuleWrite interface.
 */
export function instanceOfActionRuleWrite(value: object): value is ActionRuleWrite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('transitionAction' in (value as Record<string, any>)) && !('transition_action' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionAction'] === undefined && (value as Record<string, any>)['transition_action'] === undefined)) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function ActionRuleWriteFromJSON(json: any): ActionRuleWrite {
    return ActionRuleWriteFromJSONTyped(json, false);
}

export function ActionRuleWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionRuleWrite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'transitionAction': json['transition_action'],
        'condition': json['condition'] === undefined ? undefined : json['condition'] === null ? null : json['condition'],
        'extraParams': json['extra_params'] === undefined ? undefined : json['extra_params'] === null ? null : json['extra_params'],
        'position': json['position'],
    };
}

export function ActionRuleWriteToJSON(json: any): ActionRuleWrite {
    return ActionRuleWriteToJSONTyped(json, false);
}

export function ActionRuleWriteToJSONTyped(value?: Omit<ActionRuleWrite, 'id'|'position'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition_action': value['transitionAction'],
        'condition': value['condition'],
        'extra_params': value['extraParams'],
    };
}

